import {
  fetchDetail,
  fetchDelete,
  fetchCreate,
  fetchEdit,
} from '@/api/tag';

import { IRI } from '@/api';
import AuthResponse from '@/service/AuthResponse';
import Notifications from '@/service/Notifications';

export default {
  fetch(context, id) {
    const { commit } = context;
    commit('setIsLoading', true);
    return fetchDetail(id)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('reset');
          return;
        }
        commit('setIsLoading', false);
        commit('setItem', res);
        return res;
      })
      .catch(e => Notifications.error(
          e.toString() || 'Failed to retrieve tag',
          () => commit('reset')
        )
      )
    ;
  },
  remove({ state, commit, dispatch }, id = null) {
    commit('setIsLoading', true);
    if (!id) {
      id = state.item.id;
    }
    return fetchDelete(id)
      .then(res => AuthResponse.validateDelete(res, dispatch))
      .catch(e => Notifications.error(
        e.toString() || `Failed to delete tag: ${id}`,
        () => commit('reset')
        )
      )
      ;
  },
  save({ state, dispatch }) {
    return state.item.id ? dispatch('update') : dispatch('create');
  },
  create(context) {
    const { state, commit } = context;
    commit('setIsLoading', true);
    const payload = Object.assign({}, state.item);

    if (payload.logo && payload.logo.id) {
      payload.logo = `${IRI.storage}${payload.logo.id}`;
    }

    return fetchCreate(payload)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('reset');
          return;
        }
        commit('setIsLoading', false);
        commit('setItem', res);
        return res;
      })
      .catch(e => Notifications.error(
        e.toString() || 'Failed to create tag',
        () => commit('reset')
        )
      )
      ;
  },
  update(context) {
    const { state, commit } = context;
    commit('setIsLoading', true);
    const payload = Object.assign({}, state.item);

    return fetchEdit(payload)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('reset');
          return;
        }
        commit('setIsLoading', false);
        commit('setItem', res);
        return res;
      })
      .catch(e => Notifications.error(
        e.toString() || `Failed to save tag: ${state.item.id}`,
        () => commit('reset')
        )
      )
      ;
  },
};
